var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.id)?_c('b-button',{attrs:{"block":"","variant":"outline-danger"},on:{"click":_vm.print}},[_c('i',{staticClass:"icon-print"}),_vm._v(" Imprimir ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }